import { jsxs as _jsxs } from "react/jsx-runtime";
import useScoreStore from "../lib/stores/scoreStore";
const Score = () => {
    const { scores } = useScoreStore();
    return (_jsxs("div", { className: "flex items-center gap-10 text-2xl font-bold", children: [_jsxs("p", { children: ["X ", scores.X] }), _jsxs("p", { children: ["O ", scores.O] })] }));
};
export default Score;
